// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1YOwP","head":"Table_head__vbHee","col":"Table_col__2Buzu"};